import Button from 'src/components/generics/button'
import HeadlessModal from '../headless/modal'

const NextModal = props => {
  if (props.choices) {
    const { choices, children } = props
    return (
      <HeadlessModal {...props} open={Boolean(props.open)}>
        {children}
        {choices && (
          <div className="p-4 text-center lg:pb-8">
            {choices.map(choice => (
              <Button
                key={choice.label}
                color={choice.color}
                className="ml-2 max-lg:mb-2 max-lg:w-full max-lg:text-center lg:ml-4"
                onClick={choice.onClick}>
                {choice.label}
              </Button>
            ))}
          </div>
        )}
      </HeadlessModal>
    )
  }

  return <HeadlessModal {...props} />
}

export default NextModal
